function m(e) {
  return e.replace(/[&<>"']/g, (t) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[t]);
}
function f(e, t) {
  const c = [];
  for (const { pattern: s, cls: n } of t) {
    const p = new RegExp(s.source, s.flags);
    let l;
    for (; (l = p.exec(e)) !== null && (c.push({ start: l.index, end: l.index + l[0].length, cls: n }), !!p.global); )
      l[0].length === 0 && p.lastIndex++;
  }
  c.sort((s, n) => s.start - n.start || n.end - n.start - (s.end - s.start));
  const i = [];
  let g = 0;
  for (const s of c)
    s.start >= g && (i.push(s), g = s.end);
  let o = "", r = 0;
  for (const s of i)
    s.start > r && (o += m(e.slice(r, s.start))), o += `<span class="tok ${s.cls}">${m(e.slice(s.start, s.end))}</span>`, r = s.end;
  return r < e.length && (o += m(e.slice(r))), o;
}
const u = String.raw`\b(abstract|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b`, h = String.raw`\b(string|number|boolean|any|unknown|never|void|null|undefined|Record|Partial|Readonly|Array|Promise|Map|Set)\b`, a = {
  js: [
    { pattern: /\/\/.*/g, cls: "com" },
    { pattern: /\/\*[\s\S]*?\*\//g, cls: "com" },
    { pattern: /(['"`])(?:\\.|(?!\1)[\s\S])*\1/g, cls: "str" },
    { pattern: /\b\d[\d_]*(?:\.[\d_]+)?\b/g, cls: "num" },
    { pattern: new RegExp(u, "g"), cls: "kw" }
  ],
  ts: [
    { pattern: /\/\/.*/g, cls: "com" },
    { pattern: /\/\*[\s\S]*?\*\//g, cls: "com" },
    { pattern: /(['"`])(?:\\.|(?!\1)[\s\S])*\1/g, cls: "str" },
    { pattern: new RegExp("\\b\\d[\\d_]*(?:\\.[\\d_]+)?\\b", "g"), cls: "num" },
    { pattern: new RegExp(u, "g"), cls: "kw" },
    { pattern: new RegExp(h, "g"), cls: "type" }
  ],
  json: [
    { pattern: /"(?:\\.|[^"])*"(?=\s*:)/g, cls: "prop" },
    { pattern: /"(?:\\.|[^"])*"/g, cls: "str" },
    { pattern: /\b(true|false|null)\b/g, cls: "kw" },
    { pattern: /-?\b\d[\d.]*\b/g, cls: "num" }
  ],
  css: [
    { pattern: /\/\*[\s\S]*?\*\//g, cls: "com" },
    { pattern: /#[0-9a-fA-F]{3,8}\b/g, cls: "num" },
    { pattern: /\b\d+(\.\d+)?(px|em|rem|%|vh|vw)\b/g, cls: "num" },
    { pattern: /:[a-z-]+(?=\s*:)/g, cls: "prop" },
    { pattern: /\b(var|calc|clamp)\b/g, cls: "kw" }
  ],
  html: [
    { pattern: /<!--[\s\S]*?-->/g, cls: "com" },
    { pattern: /<\/?[a-zA-Z][\w:-]*/g, cls: "tag" },
    { pattern: /\s+[a-zA-Z_:][\w:.-]*(?==)/g, cls: "attr" },
    { pattern: /"[^"]*"|'[^']*'/g, cls: "str" },
    { pattern: /\/?>/g, cls: "tag" }
  ],
  bash: [
    { pattern: /#.*/g, cls: "com" },
    { pattern: /\$[A-Za-z_]\w*/g, cls: "var" },
    { pattern: /(['"`])(?:\\.|(?!\1)[\s\S])*\1/g, cls: "str" },
    { pattern: /^\s*[a-zA-Z][\w-]*/gm, cls: "kw" },
    { pattern: /\b\d+\b/g, cls: "num" }
  ],
  ini: [
    { pattern: /;.*/g, cls: "com" },
    { pattern: /^\s*\[[^\]]+\]/gm, cls: "kw" },
    { pattern: /^\s*[A-Za-z0-9_.-]+\s*(?==)/gm, cls: "prop" },
    { pattern: /=\s*".*?"|=\s*'.*?'|=\s*\S+/g, cls: "str" }
  ],
  md: [
    { pattern: /^###[^\n]+/gm, cls: "kw" },
    { pattern: /^##[^\n]+/gm, cls: "kw" },
    { pattern: /^#[^\n]+/gm, cls: "kw" },
    { pattern: /`[^`]+`/g, cls: "code" },
    { pattern: /\*\*[^*]+\*\*/g, cls: "strong" },
    { pattern: /\*[^*]+\*/g, cls: "em" }
  ]
};
function d(e) {
  const t = e.replace(/^language-/, "").toLowerCase();
  return t === "ts" || t === "tsx" || t === "typescript" ? a.ts : t === "js" || t === "jsx" || t === "mjs" || t === "cjs" || t === "javascript" ? a.js : t === "json" || t === "jsonc" ? a.json : t === "html" || t === "xml" || t === "svg" ? a.html : t === "css" || t === "scss" || t === "less" ? a.css : t === "bash" || t === "sh" || t === "shell" || t === "zsh" || t === "fish" ? a.bash : t === "ini" || t === "conf" || t === "toml" ? a.ini : t === "md" || t === "markdown" ? a.md : [];
}
function w() {
  return (e) => {
    const t = e.options.hooks?.afterPreviewRender;
    e.options.hooks = e.options.hooks || {}, e.options.hooks.afterPreviewRender = (c, i) => {
      t?.(c, i), c.querySelectorAll('pre code[class*="language-"]').forEach((o) => {
        const r = o;
        if (r.dataset.hl === "1") return;
        const s = [...r.classList].find((l) => l.startsWith("language-")), n = d(s);
        if (!n.length) {
          r.dataset.hl = "1";
          return;
        }
        const p = r.textContent || "";
        r.innerHTML = f(p, n), r.closest("pre")?.classList.add("marzipan-highlight"), r.dataset.hl = "1";
      });
    };
  };
}
const k = `
.marzipan-highlight { line-height: 1.5; overflow: auto; border-radius: 8px; }
.tok.kw { color: var(--mz-k, #c678dd); font-weight: 600; }
.tok.type { color: var(--mz-t, #56b6c2); }
.tok.prop { color: var(--mz-p, #e5c07b); }
.tok.num { color: var(--mz-n, #d19a66); }
.tok.str { color: var(--mz-s, #98c379); }
.tok.com { color: var(--mz-c, #7f848e); font-style: italic; }
.tok.tag { color: var(--mz-tag, #e06c75); }
.tok.attr { color: var(--mz-attr, #61afef); }
.tok.var { color: var(--mz-var, #61afef); }
.tok.code { color: var(--mz-code, #e5c07b); }
.tok.strong { font-weight: 700; }
.tok.em { font-style: italic; }
`;
export {
  w as tinyHighlightPlugin,
  k as tinyHighlightStyles
};
//# sourceMappingURL=tinyHighlight.js.map
